import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  static targets = ['trigger', 'popup']

  declare readonly triggerTarget: HTMLButtonElement
  declare readonly popupTarget: HTMLDivElement

  clickTrigger(): void {
    const triggerRect = this.triggerTarget.getBoundingClientRect()
    this.popupTarget.style.top = triggerRect.bottom - 8 + 'px'
    this.popupTarget.style.left =
      triggerRect.left - this.popupTarget.clientWidth + triggerRect.width + 'px'
  }
}
